import React, { PureComponent } from 'react'

// local components
import DevKeyItem from './DevKeyItem'
import EditableHOCWrapper from '../../containers/HOC/EditableHOC'

const DevKeyItemEditable = EditableHOCWrapper(DevKeyItem)

class DevKeyItemContainer extends PureComponent {
  onSave = (data, afterOnSave) => {
    this.props.onDevKeyUpdate(data, afterOnSave)
  }

  render() {
    const {
      devKey = {},
      lastModified = null,
      defaultEditMode = false,
      onCancel,
      onDelete,
      shops,
    } = this.props

    return (
      <DevKeyItemEditable
        dataToEdit={devKey}
        onSave={this.onSave}
        lastModified={lastModified}
        defaultEditMode={defaultEditMode}
        onCancel={onCancel}
        onDelete={onDelete}
        shops={shops}
      />
    )
  }
}

export default DevKeyItemContainer



// WEBPACK FOOTER //
// ./src/components/DevKeys/DevKeyItemContainer.js